/**
 * API Configuration
 * 
 * REACT_APP_API_URL must be set via environment variables or amplify.yml
 * There is no fallback - the environment must be properly configured.
 */

if (!process.env.REACT_APP_API_URL) {
  throw new Error('REACT_APP_API_URL environment variable is not set. Check amplify.yml or .env configuration.');
}

export const API_BASE_URL = process.env.REACT_APP_API_URL;

export default API_BASE_URL;
